import plural from 'helpers/plural';

angular.module('filters').filter('membershipPlanClassAccessFilter', function() {
  return function(membershipPlan) {
    var classString, intervalNumberString, intervalString, intervalUnitString;
    classString = plural('classes', membershipPlan.classes_limit);
    intervalUnitString = plural(membershipPlan.classes_interval_unit, membershipPlan.classes_interval_number);
    intervalNumberString = membershipPlan.classes_interval_number > 1 ? membershipPlan.classes_interval_number : '';
    intervalString = membershipPlan.classes_interval_number ? `every ${intervalNumberString} ${intervalUnitString}` : "anytime";
    switch (false) {
      case !membershipPlan.classes_unlimited:
        return "Unlimited";
      case !membershipPlan.classes_limit:
        return `${membershipPlan.classes_limit} ${classString} to use ${intervalString}`;
      default:
        return `${membershipPlan.classes_limit} ${classString}`;
    }
  };
});
